export default function toArray() {
  return Array.from(arguments).flat();
}
